/* ============================================================
   VP HEADER JS
   Scoped to [data-vp-header] so multiple/duplicate sections
   never collide. Re-runs on 'shopify:section:load' so it keeps
   working inside the theme editor.
   ============================================================ */
(function(){
  function initHeader(root){
    var header = root.querySelector('[data-vp-header]');
    if(!header || header.dataset.vpInit) return;
    header.dataset.vpInit = '1';

    function onScroll(){
      var y = window.scrollY;
      header.classList.toggle('compact', y > 250);
      if(header.classList.contains('mega-open')) return;
      header.classList.toggle('solid', y > 60);
      header.classList.toggle('clear', y <= 60);
    }
    addEventListener('scroll', onScroll, {passive:true});
    onScroll();

    /* ---- Mega menu (desktop hover / focus) ---- */
    var navLinks = [].slice.call(header.querySelectorAll('[data-vp-mega]'));
    var panels    = [].slice.call(header.parentNode.querySelectorAll('[data-vp-panel]'));

    function closeMega(){
      header.classList.remove('mega-open');
      panels.forEach(function(p){ p.classList.remove('is-on'); });
      navLinks.forEach(function(a){ a.classList.remove('is-active'); });
      onScroll();
    }
    function openMega(name){
      /* Opens over the search sheet too: the bar is lifted above the sheet
         while search is open (vp-header.css, search-open) and the panels
         sit inside it, so the menu draws on top and the sheet stays put
         underneath for when the pointer leaves. */
      panels.forEach(function(p){ p.classList.toggle('is-on', p.dataset.vpPanel === name); });
      navLinks.forEach(function(a){ a.classList.toggle('is-active', a.dataset.vpMega === name); });
      header.classList.add('mega-open');
      header.classList.remove('clear','solid');
    }
    navLinks.forEach(function(a){
      a.addEventListener('mouseenter', function(){ openMega(a.dataset.vpMega); });
      a.addEventListener('focus', function(){ openMega(a.dataset.vpMega); });
      /* Click toggles: mouseenter won't refire while the pointer stays on
         the link, so a second click has to be what brings the panel back. */
      a.addEventListener('click', function(){
        if(a.classList.contains('is-active')) setTimeout(closeMega, 60);
        else openMega(a.dataset.vpMega);
      });
    });
    header.addEventListener('mouseleave', closeMega);
    /* The menu belongs to the nav row and the panel under it. Moving up
       into the top bar -- the wordmark or the search / wishlist / account
       / cart icons -- is leaving it, so it closes there too rather than
       hanging open until the pointer exits the whole header. */
    var bar = header.querySelector('.vp-hd-bar');
    if(bar) bar.addEventListener('mouseenter', function(){
      if(header.classList.contains('mega-open')) closeMega();
    });
    /* Search icon: the sheet takes over the viewport, so any open mega goes
       first. Hovering a nav link afterwards reopens it over the sheet. */
    [].forEach.call(header.querySelectorAll('[data-vp-search-open]'), function(btn){
      btn.addEventListener('click', closeMega);
    });
    addEventListener('scroll', function(){ if(header.classList.contains('mega-open')) closeMega(); }, {passive:true});

    /* ---- Cart icon: open the theme's native cart drawer ---- */
    var cartLink = header.querySelector('[data-vp-cart-link]');
    if(cartLink){
      cartLink.addEventListener('click', function(e){
        var drawer = document.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer]');
        if(drawer && typeof drawer.show === 'function'){
          e.preventDefault();
          drawer.show();
        }
        /* else: falls through to routes.cart_url — normal cart page */
      });
    }

    /* ---- Open-state ring: the icon whose surface is up keeps its ring ----
       The cart drawer and the wishlist modal cover the bar, so :hover ends
       as they open. Each is watched for its own open marker -- the drawer's
       open attribute, the modal's is-open class -- and the icon that owns it
       carries .is-on for as long as it shows (vp-header.css draws the ring
       and lift for .is-on). Watching the surface rather than the click means
       the state is right however the surface was opened or closed. The
       search icon needs nothing here: the bar's search-open class does it.
       The sign-in sheet is a <dialog> inside <shopify-account>'s shadow
       root (open, so it can be read); the host carries .is-on while that
       dialog is open. */
    function mirrorOpen(trigger, surface, isOpen){
      if(!trigger || !surface || typeof MutationObserver !== 'function') return;
      var sync = function(){ trigger.classList.toggle('is-on', isOpen(surface)); };
      new MutationObserver(sync).observe(surface, { attributes: true, attributeFilter: ['open', 'class', 'hidden'] });
      sync();
    }
    var wishTrigger = header.querySelector('[data-vp-wish-toggle]');
    var wishDialog = document.getElementById('vp-wishlist-dialog');
    mirrorOpen(wishTrigger, wishDialog, function(el){ return el.classList.contains('is-open'); });
    mirrorOpen(cartLink, document.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer]'),
      function(el){ return el.hasAttribute('open'); });
    var account = header.querySelector('shopify-account');
    if(account && typeof MutationObserver === 'function'){
      /* Which input closed the sheet. On close the component puts focus back
         on its own trigger button, inside the shadow root, and the host then
         matches the :focus-within ring rule (vp-header.css) -- so after a
         click on the backdrop the ring simply stayed. A pointer close lets
         that focus go; a keyboard close (Esc) keeps it, so the ring then
         rightly marks where focus is. */
      var byPointer = false, px = -1, py = -1;
      document.addEventListener('pointerdown', function(e){ byPointer = true; px = e.clientX; py = e.clientY; }, true);
      document.addEventListener('pointermove', function(e){ px = e.clientX; py = e.clientY; }, true);
      document.addEventListener('keydown', function(){ byPointer = false; }, true);
      /* Chrome rebuilds the hover chain when the modal <dialog> closes, but
         stops it at the shadow boundary: the glyph under the pointer is
         :hover, the host that carries the ring rules is not, until the
         pointer leaves and returns. So a click on the icon's own spot to
         dismiss the sheet left the icon bare while the wishlist's stayed
         ringed. .is-hover stands in for :hover (vp-header.css) from the
         close until the pointer really leaves the icon. */
      var overIcon = function(){
        if(px < 0) return false;
        var el = document.elementFromPoint(px, py);
        return !!el && account.contains(el);
      };
      document.addEventListener('pointermove', function(){
        if(account.classList.contains('is-hover') && !overIcon()) account.classList.remove('is-hover');
      });
      var watchAccount = function(){
        var root = account.shadowRoot;
        if(!root) return false;
        var wasOpen = false;
        var sync = function(){
          var isOpen = !!root.querySelector('dialog[open], .dialog[open]');
          account.classList.toggle('is-on', isOpen);
          /* The sheet is a native <dialog>: modal, but the page behind it
             still scrolls, so the bar went compact and the icon slid about
             under the veil. The wishlist modal holds the page still with
             this class (layout/theme.liquid); the sheet now does the same. */
          document.body.classList.toggle('vp-account-modal-locked', isOpen);
          if(wasOpen && !isOpen && byPointer){
            var release = function(){
              var inner = root.activeElement;
              if(inner && typeof inner.blur === 'function') inner.blur();
              else if(document.activeElement === account) account.blur();
            };
            /* Now, and again next frame in case the focus hand-back lands
               after the attribute change. */
            release();
            requestAnimationFrame(release);
            if(overIcon()) account.classList.add('is-hover');
          }
          wasOpen = isOpen;
        };
        /* The component re-renders its inner wrapper, so the dialog node can
           be replaced: watch the whole subtree, not one element. */
        new MutationObserver(sync).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['open'] });
        sync();
        return true;
      };
      if(!watchAccount() && window.customElements && customElements.whenDefined){
        customElements.whenDefined('shopify-account').then(function(){
          /* The shadow root is attached on upgrade; give it a frame or two. */
          var tries = 0;
          (function retry(){ if(!watchAccount() && ++tries < 60) requestAnimationFrame(retry); })();
        });
      }
    }

    /* ---- Live cart count: update the header badge without a page reload ---- */
    document.addEventListener('cart:change', function(e){
      if(!e.detail || !e.detail.cart) return;
      var count = e.detail.cart.item_count;
      var bagLink = header.querySelector('[data-vp-cart-link]');
      if(!bagLink) return;
      var badge = bagLink.querySelector('.vp-bag-count');
      if(count > 0){
        if(!badge){
          badge = document.createElement('span');
          badge.className = 'vp-bag-count';
          bagLink.appendChild(badge);
        }
        badge.textContent = count;
      } else if(badge){
        badge.remove();
      }
    });

    /* ---- Wishlist hover pop, if present ---- */
    var wishWrap = header.querySelector('[data-vp-wish]');
    if(wishWrap){
      var wishBtn = wishWrap.querySelector('[data-vp-wish-toggle]');
      if(wishBtn){
        wishBtn.addEventListener('click', function(e){
          e.stopPropagation();
          wishWrap.classList.toggle('open');
        });
      }
      document.addEventListener('click', function(e){
        if(!wishWrap.contains(e.target)) wishWrap.classList.remove('open');
      });
    }

    /* ---- Mobile drawer ---- */
    var mnav = document.querySelector('[data-vp-mnav]');
    var openBtns = header.querySelectorAll('[data-vp-mnav-open]');
    var closeBtns = document.querySelectorAll('[data-vp-mnav-close]');
    openBtns.forEach(function(b){ b.addEventListener('click', function(){
      mnav.classList.add('open'); document.body.classList.add('vp-locked');
    }); });
    closeBtns.forEach(function(b){ b.addEventListener('click', function(){
      mnav.classList.remove('open'); document.body.classList.remove('vp-locked');
    }); });
    if(mnav){
      mnav.querySelectorAll('[data-vp-macc-toggle]').forEach(function(btn){
        btn.addEventListener('click', function(){
          var acc = btn.closest('.vp-macc');
          var wasOpen = acc.classList.contains('open');
          mnav.querySelectorAll('.vp-macc').forEach(function(a){ a.classList.remove('open'); });
          if(!wasOpen) acc.classList.add('open');
        });
      });
    }
    addEventListener('keydown', function(e){
      if(e.key === 'Escape'){ closeMega(); if(mnav){ mnav.classList.remove('open'); document.body.classList.remove('vp-locked'); } }
    });
  }

  function boot(){ document.querySelectorAll('[data-vp-header]').forEach(function(h){ initHeader(document); }); }
  if(document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function(e){ initHeader(e.target); });
})();